import { render } from "./QuestionMarkSolid.vue?vue&type=template&id=a0ba587e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__